import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router';
import { replace } from 'react-router-redux';
import qs from 'qs';
import { Accordion, Button, Container, Dimmer, Dropdown, Grid, Header, Icon, Loader, Menu, Popup, Table, Transition } from 'semantic-ui-react';
import config from '../../../../config';
import { fetchM } from '../../../actions/fetchM';
import { namespaces, TRANSLATION_FILES } from '../../../constants/translation';
import { routes } from '../navigations';
import NavBar from '../../../components/NavBar';
import { BookingSelectListMultiple } from '../../../components/UpdatedComponents/UCBookingSelectListMultiple';
import { BookingSelectList } from '../../../components/UpdatedComponents/UCBookingSelectList';
import { DEVELOPER_CANCELLED, getLawyerCaseStatuses, LAWYER_ALL_STATUSES, TYPE_CASE_SPA, TYPE_CASE_LA } from '../../../constants/lawyerCaseStatuses';
import { decodeSearch, encodeSearch } from '../../../utils/url';
import SearchIn from '../../../components/UpdatedComponents/UCSearchIn';
import BANK_CASE_STATUSES from '../../../constants/bankCaseStatuses';
import BookingDatePicker from '../../../components/UpdatedComponents/UCBookingDatePicker';
import PageNav from '../../../components/PageNav';
import StatusFlag from '../../../components/UpdatedComponents/Basic/UCBStatusFlag';
import Timestamp from '../../../components/Timestamp';
import { flashErrorMessage } from '../../../actions/flash';
import DownloadSvg from '../../../assets/icons/download.svg';
import SortSvg from '../../../assets/icons/sort.svg';
import SortButton from '../../../components/UpdatedComponents/UCSortButton';

const allFilterNames = [
  'search',
  'bookingStatusMulti',
  'dateRange',
  'dateFrom',
  'dateTo',
  'approvedDateRange',
  'approvedDateFrom',
  'approvedDateTo',
  'filteredProjects',
  'loanStatus',
  'spaLawyerStatus',
  'laLawyerStatus',
];

class UnitProgress extends Component {
  static propTypes = {
    auth: PropTypes.shape({
      isDeveloperSupervisor: PropTypes.bool,
      isDeveloperSalesManager: PropTypes.bool,
      isDeveloperSalesAdmin: PropTypes.bool,
      isHeadquarters: PropTypes.bool,
      isSuperAdmin: PropTypes.bool,
      isAdminBasic: PropTypes.bool,
      isAdmin: PropTypes.bool,
    }),
    location: PropTypes.shape({
      pathname: PropTypes.string,
      query: PropTypes.object,
      search: PropTypes.string,
    }),
    t: PropTypes.func,
  }
  static contextTypes = {
    store: PropTypes.object,
  }
  static mapStateToProps = state => ({
    auth: state.auth,
  })
  static getPropsToState = (props) => {
    const query = decodeSearch(props.location.search);
    const menuIsTab = window.innerWidth <= 590;
    const currentPage = parseInt(query.page, 10) || 1;
    const search = query.search || '';
    const dateRange = query.dateRange || '';
    const dateFrom = query.dateFrom || '';
    const dateTo = query.dateTo || '';
    const approvedDateRange = query.approvedDateRange || '';
    const approvedDateFrom = query.approvedDateFrom || '';
    const approvedDateTo = query.approvedDateTo || '';
    const loanStatus = query.loanStatus || [];
    const spaLawyerStatus = query.spaLawyerStatus || '';
    const laLawyerStatus = query.laLawyerStatus || '';
    let filteredProjects = [];
    if (query.projectFilter) {
      try {
        const decoded = atob(query.projectFilter);
        filteredProjects = decoded ? decoded.split(',').filter(Boolean) : [];
      } catch (e) {
        filteredProjects = [];
      }
    }
    return {
      menuIsTab,
      currentPage,
      search,
      dateRange,
      dateFrom,
      dateTo,
      approvedDateRange,
      approvedDateFrom,
      approvedDateTo,
      loanStatus,
      spaLawyerStatus,
      laLawyerStatus,
      filteredProjects,
    };
  }
  constructor(props) {
    super(props);
    const state = UnitProgress.getPropsToState(props);
    this.state = {
      loading: true,
      activeAccordionIndex: -1,
      count: 0,
      filteredProjects: [],
      isComputer: window.innerWidth > 992,
      isMobile: window.innerWidth <= 590,
      isTablet: window.innerWidth > 590 && window.innerWidth <= 992,
      limit: 0,
      loadingProjectSearch: false,
      offset: 0,
      projectOpts: [],
      unitProgress: [],
      ...state,
    };
  }
  componentDidMount() {
    window.addEventListener('resize', this.handleResize, false);
    this.fetchProjects();
    this.fetchUnitProgress(decodeSearch(this.props.location.search));
  }
  componentWillReceiveProps(nextProps) {
    const state = UnitProgress.getPropsToState(nextProps);
    this.setState(state);
  }
  componentWillUnmount() {
    window.removeEventListener('resize', this.handleResize, false);
  }
  getAllFilterNames = (removeBookingStatus = false) => {
    if (removeBookingStatus) return allFilterNames.filter(fn => fn !== 'bookingStatusMulti');
    return allFilterNames;
  }
  getRowClassName = (statusID) => {
    if (statusID === 'cancelled_availability') {
      return 'row-colors booking_row_cancelled_availability';
    }
    if (statusID === 'cancelled_developer' || statusID === DEVELOPER_CANCELLED) {
      return 'row-colors booking_row_cancelled_developer';
    }
    return 'row-colors';
  }
  setLoading = (loading) => {
    this.setState({ loading });
  }
  handleResize = () => {
    const state = {};
    const menuIsTab = window.innerWidth <= 590;
    if (menuIsTab !== this.state.menuIsTab) {
      state.menuIsTab = menuIsTab;
    }
    this.setState({ ...state });
  }
  handleMenu = (e, { value }) => {
    const { store } = this.context;
    store.dispatch(replace(value));
  }
  handleAccordionClick(e, valIndex) {
    const { index } = valIndex;
    this.setState(prevState => ({
      activeAccordionIndex: prevState.activeAccordionIndex === index ? -1 : index,
    }));
  }
  handleFilterProjects = (e, { name, value }) => {
    // eslint-disable-next-line no-nested-ternary
    const filteredProjects = Array.isArray(value) ? value : (value ? [value] : []);
    this.setState({ filteredProjects }, () => {
      const query = decodeSearch(this.props.location.search);
      if (filteredProjects.length > 0) {
        query[name] = btoa(filteredProjects.join(','));
      } else {
        delete query[name];
      }
      this.replaceQuery(query, true);
    });
  }
  handleChangePage = (currentPage) => {
    const query = decodeSearch(this.props.location.search);
    query.page = currentPage;
    this.setState({ currentPage }, () => {
      this.replaceQuery(query);
    });
  }
  handleFilterOnChange = (value, queryName) => {
    const query = decodeSearch(this.props.location.search);
    query[queryName] = value;
    if (queryName === 'search') {
      delete query.searchIn;
    }
    if (queryName === 'loanStatus') {
      delete query.sortColumn;
      delete query.sortDirection;
    }
    // Most filter changes should fetch immediately; only custom ranges wait for both dates.
    let refetch = true;
    if (queryName === 'dateRange' && query.dateRange === 'custom' && (!query.dateFrom || !query.dateTo)) {
      refetch = false;
    }
    if (queryName === 'approvedDateRange' && query.approvedDateRange === 'custom' && (!query.approvedDateFrom || !query.approvedDateTo)) {
      refetch = false;
    }
    this.replaceQuery(query, true, refetch);
  }
  handleClearFilter = (...queryArray) => {
    let hasQuery = false;
    let clearSearch = false;
    const query = decodeSearch(this.props.location.search);
    const filterArray = [...queryArray];
    filterArray.forEach((filter) => {
      if (filter === 'search') {
        clearSearch = true;
      }
      if (filter === 'loanStatus') {
        delete query.sortColumn;
        delete query.sortDirection;
      }
      if (filter === 'filteredProjects') {
        delete query.projectCode;
        delete query.projectFilter;
        hasQuery = true;
        this.setState({
          filteredProjects: [],
          isChanging: false,
        });
      }
      if (query[filter] !== undefined) {
        delete query[filter];
        hasQuery = true;
        this.setState({ isChanging: false });
      }
    });
    const cb = () => {
      if (hasQuery) {
        this.replaceQuery(query, true);
      }
    };
    if (clearSearch) {
      delete query.searchIn;
      this.setState({ search: '' }, () => {
        cb();
      });
    } else {
      cb();
    }
  }
  handleSetDateRange = (name, from, to) => {
    const query = decodeSearch(this.props.location.search);
    switch (name) {
      case 'dateRange':
        query.dateFrom = from;
        query.dateTo = to;
        break;
      case 'approvedDateRange':
        query.approvedDateFrom = from;
        query.approvedDateTo = to;
        break;
      default:
        break;
    }
    this.replaceQuery(query, true);
  }
  handleReplaceStatus = (status = '') => {
    const query = decodeSearch(this.props.location.search);
    if (status !== '') {
      query.bookingStatus = status;
    } else {
      delete query.bookingStatus;
    }
    this.replaceQuery(query);
  }
  replaceQuery(query, resetPage = false, fetch = true) {
    const { store } = this.context;
    const { pathname, search } = this.props.location;
    const queryNew = query;
    if (resetPage) {
      queryNew.page = 1;
    }
    const bookingStatus = decodeSearch(search).bookingStatus;
    const bookingStatusMulti = decodeSearch(search).bookingStatusMulti;
    const loanStatus = decodeSearch(search).loanStatus;
    const spaLawyerStatus = decodeSearch(search).spaLawyerStatus;
    const laLawyerStatus = decodeSearch(search).laLawyerStatus;
    if (
      (query.bookingStatus && !bookingStatus) ||
      (query.bookingStatusMulti && !bookingStatusMulti) ||
      (query.loanStatus && !loanStatus) ||
      (query.spaLawyerStatus && !spaLawyerStatus) ||
      (query.laLawyerStatus && !laLawyerStatus)
    ) {
      queryNew.page = 1;
    }
    if (fetch) {
      this.fetchUnitProgress(queryNew);
    }
    store.dispatch(replace(`${pathname}?${encodeSearch(queryNew)}`));
  }
  async exportURL(fileType, primary = false, detailed = false) {
    const { location } = this.props;
    const { filteredProjects, projectFilter } = this.state;
    let url = `${config.get('bookApiURL')}/reports/bookings/`;
    if (location && location.search) {
      url += `${location.search}`;
    }
    if (filteredProjects && filteredProjects.length > 0) {
      url += `&projectFilter=${projectFilter}`;
    }
    if (primary) {
      url += '&primaryOnly=true';
    }
    url += `&fileType=${fileType}`;
    if (detailed) {
      url += '&detailed=true';
    }
    return url;
  }
  async fetchProjects() {
    const { store } = this.context;
    const { t } = this.props;
    const query = Object.assign({
      limit: 0,
      showAsOptions: false,
    });
    this.setState({ loadingProjectSearch: true });
    let res;

    try {
      res = await store.dispatch(fetchM(`/projects/?${qs.stringify(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
    } catch (err) {
      if (err.res && err.res.status >= 399 && err.res.status < 500) {
        const message = await err.res.text();
        store.dispatch(flashErrorMessage({ message }));
      }
      this.setState({ loadingProjectSearch: false });
      store.dispatch(flashErrorMessage({ message: `${t('There was an error with your request. Please try again', { ns: TRANSLATION_FILES.translation })}.` }));
      return;
    }
    if (!res.ok) {
      const message = await res.text();
      await store.dispatch(flashErrorMessage({ message }));
    } else {
      const data = await res.json();
      let projectOpts = [];
      if (data && data.length > 0) {
        projectOpts = data.map(d => ({ value: d.id, text: d.name }));
      }
      this.setState({ projectOpts });
    }
    this.setState({ loadingProjectSearch: false });
  }
  fetchUnitProgress = async (query) => {
    const { store } = this.context;
    this.setLoading(true);
    try {
      const res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/bookings/unit_progress/?${encodeSearch(query)}`, {
        credentials: 'include',
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      }));
      if (res.ok) {
        const unitProgress = await res.json();
        this.setState({ unitProgress });
      }
    } catch (err) {
      // fetchM already handles auth/network dispatching; keep this view resilient.
    } finally {
      this.setLoading(false);
    }
  }
  renderStatusDateFilter = () => {
    const { t } = this.props;
    const { bookingStatus, loading, isMobile } = this.state;
    let filter = '';
    let filterFrom = '';
    let filterTo = '';
    let headerText = '';
    switch (bookingStatus) {
      case 'cancelled_developer':
        filter = 'cancelledDateRange';
        filterFrom = 'cancelledDateFrom';
        filterTo = 'cancelledDateTo';
        headerText = 'Cancelled Date Range';
        break;
      case 'expired':
        filter = 'expiredDateRange';
        filterFrom = 'expiredDateFrom';
        filterTo = 'expiredDateTo';
        headerText = 'Expired Date Range';
        break;
      case 'booked':
        filter = 'bookedDateRange';
        filterFrom = 'bookedDateFrom';
        filterTo = 'bookedDateTo';
        headerText = 'Booked Date Range';
        break;
      case 'sold_spa_signed':
        filter = 'soldDateRange';
        filterFrom = 'soldDateFrom';
        filterTo = 'soldDateTo';
        headerText = 'Sold Date Range';
        break;
      default:
        break;
    }
    return filter && (
      <Grid.Column
        className="filter tight-column"
        mobile={16}
        tablet={5}
        computer={5}
        style={{ paddingBottom: isMobile ? '1rem' : '0rem' }}
      >
        <BookingDatePicker
          filterName={filter}
          filterNameFrom={filterFrom}
          filterNameTo={filterTo}
          headerText={t(headerText, { ns: TRANSLATION_FILES.screens })}
          placeholder={t(`Select ${headerText}`, { ns: TRANSLATION_FILES.screens })}
          dateFrom={this.state[filterFrom]}
          dateTo={this.state[filterTo]}
          onChange={this.handleFilterOnChange}
          onClose={this.handleClearFilter}
          onResetRange={this.handleClearFilter}
          onSetRange={(from, to) => this.handleSetDateRange(filter, from, to)}
          value={this.state[filter]}
          disabled={loading}
          label={t(headerText, { ns: TRANSLATION_FILES.screens })}
        />
      </Grid.Column>
    );
  }
  renderDefaultClearFilter = () => {
    const { isMobile, search } = this.state;
    const { t } = this.props;
    return (
      (this.getAllFilterNames(false).some(filterName => this.state[filterName] &&
        this.state[filterName].length > 0) || search.length > 0) && (
        <Grid.Row style={{ paddingBottom: '0rem', paddingTop: isMobile ? '0rem' : '1rem' }}>
          <Grid.Column
            verticalAlign="middle"
          >
            <Button
              className="uc-clear-button"
              content={t('Clear all', { ns: TRANSLATION_FILES.translation })}
              onClick={() => this.handleClearFilter(...this.getAllFilterNames(false))}
            />
          </Grid.Column>
        </Grid.Row>)
    );
  }
  renderAccordionDefaultView = () => {
    const { t } = this.props;
    const { loading, loadingProjectSearch, activeAccordionIndex, isTablet, isMobile } = this.state;

    return (
      <Accordion fluid className="uc-accordion shadow-border" style={{ paddingBottom: !isMobile && activeAccordionIndex !== 0 ? '1.5rem' : '0.5rem' }}>
        <Accordion.Title
          style={{ paddingBottom: '1rem' }}
          active={activeAccordionIndex === 0}
          index={0}
        >
          <Grid>
            <Grid.Row columns="equal" style={{ paddingBottom: activeAccordionIndex === 0 ? '1rem' : '0rem' }}>
              <Grid.Column
                className="tight-column"
                tablet={5}
                computer={5}
              >
                <SearchIn
                  isLoading={loading}
                  onChange={this.handleFilterOnChange}
                  onClear={this.handleClearFilter}
                  search={this.state.search}
                  label={t('Keywords', { ns: TRANSLATION_FILES.screens })}
                  isFullSize
                />
              </Grid.Column>
              <Grid.Column
                className="filter tight-column"
                tablet={5}
                computer={5}
              >
                <div className="field">
                  <label
                    className="ui"
                    htmlFor="projectFilter"
                    style={{ fontWeight: 'bold', margin: '0 0 0.28571429rem 0', fontSize: '.92857143em', display: 'block' }}
                  >
                    {t('Projects', { ns: TRANSLATION_FILES.screens })}
                  </label>
                  <Dropdown
                    fluid
                    search
                    selection
                    floating
                    disabled={loading || loadingProjectSearch}
                    loading={loadingProjectSearch}
                    multiple
                    name="projectFilter"
                    onChange={this.handleFilterProjects}
                    options={this.state.projectOpts}
                    placeholder={t('Find Project')}
                    value={this.state.filteredProjects}
                    noResultsMessage={t('No results found', { ns: TRANSLATION_FILES.translation })}
                  />
                </div>
              </Grid.Column>
              <Grid.Column
                className="filter tight-column"
                tablet={5}
                computer={5}
              >
                <BookingSelectListMultiple
                  filterName="loanStatus"
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  options={BANK_CASE_STATUSES.map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                  placeholder={t('Loan Status')}
                  value={this.state.loanStatus}
                  disabled={loading}
                  label={t('Loan Status', { ns: TRANSLATION_FILES.screens })}
                />
              </Grid.Column>
              <Grid.Column width={1} style={{ paddingLeft: isTablet ? '0rem' : '0.7rem' }} textAlign="left">
                <Popup
                  size="tiny"
                  style={{ backgroundColor: '#596975' }}
                  basic
                  inverted
                  content={activeAccordionIndex === 0 ? t('Collapse', { ns: TRANSLATION_FILES.translation }) : t('Expand', { ns: TRANSLATION_FILES.translation })}
                  position="bottom center"
                  trigger={
                    <Button
                      icon
                      circular
                      onClick={e => this.handleAccordionClick(e, { index: activeAccordionIndex === 0 ? -1 : 0 })}
                      className={`uc-accordion-toggle-btn ${activeAccordionIndex === 0 ? 'rotated' : ''}`}
                    >
                      <Icon name="chevron down" />
                    </Button>
                  }
                />
              </Grid.Column>
            </Grid.Row>
            {activeAccordionIndex !== 0 && this.renderDefaultClearFilter()}
          </Grid>
        </Accordion.Title>
        <Transition visible={activeAccordionIndex === 0} animation="slide down" duration={200}>
          <Accordion.Content active={activeAccordionIndex === 0} style={{ paddingBottom: '2rem' }}>
            <Grid
              // className="filters booking"
              textAlign="left"
              verticalAlign="middle"
            >
              <Grid.Column
                className="filter tight-column"
                tablet={5}
                computer={5}
              >
                <BookingSelectList
                  filterName="spaLawyerStatus"
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  options={getLawyerCaseStatuses(TYPE_CASE_SPA).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                  placeholder={t('Case Type')}
                  value={this.state.spaLawyerStatus}
                  disabled={loading}
                  label={t('SPA Status', { ns: TRANSLATION_FILES.screens })}
                />
              </Grid.Column>
              <Grid.Column
                className="filter tight-column"
                tablet={5}
                computer={5}
              >
                <BookingSelectList
                  filterName="laLawyerStatus"
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  options={getLawyerCaseStatuses(TYPE_CASE_LA).map(({ value, text }) => ({ value, text: t(text, { ns: TRANSLATION_FILES.constants }) }))}
                  placeholder={t('Case Type')}
                  value={this.state.laLawyerStatus}
                  disabled={loading}
                  label={t('LA Status', { ns: TRANSLATION_FILES.screens })}
                />
              </Grid.Column>
              <Grid.Column
                className="filter tight-column"
                tablet={5}
                computer={5}
              >
                <BookingDatePicker
                  filterName="dateRange"
                  filterNameFrom="dateFrom"
                  filterNameTo="dateTo"
                  headerText={t('Created Date Range')}
                  placeholder={t('Select Created Date Range')}
                  dateFrom={this.state.dateFrom}
                  dateTo={this.state.dateTo}
                  onChange={this.handleFilterOnChange}
                  onClose={this.handleClearFilter}
                  onResetRange={this.handleClearFilter}
                  onSetRange={(from, to) => this.handleSetDateRange('dateRange', from, to)}
                  value={this.state.dateRange}
                  disabled={loading}
                  label={t('Created Date Range')}
                />
              </Grid.Column>
              <Grid.Row style={{ paddingBottom: '0rem' }}>
                <Grid.Column
                  className="filter tight-column"
                  tablet={5}
                  computer={5}
                >
                  <BookingDatePicker
                    filterName="approvedDateRange"
                    filterNameFrom="approvedDateFrom"
                    filterNameTo="approvedDateTo"
                    headerText={t('Approved Date Range')}
                    placeholder={t('Select Approved Date Range')}
                    dateFrom={this.state.approvedDateFrom}
                    dateTo={this.state.approvedDateTo}
                    onChange={this.handleFilterOnChange}
                    onClose={this.handleClearFilter}
                    onResetRange={this.handleClearFilter}
                    onSetRange={(from, to) => this.handleSetDateRange('approvedDateRange', from, to)}
                    value={this.state.approvedDateRange}
                    disabled={loading}
                    label={t('Approved Date Range')}
                  />
                </Grid.Column>
              </Grid.Row>
              {this.renderDefaultClearFilter()}
            </Grid>
          </Accordion.Content>
        </Transition>
      </Accordion>
    );
  }
  renderMenuTool = () => {
    return (
      <Grid columns="equal">
        <Grid.Row>
          {this.renderAccordionDefaultView()}
        </Grid.Row>
      </Grid>
    );
  }
  renderTableHeaders = () => {
    const { t } = this.props;
    return (
      <Table.Header className="mobile-hide">
        <Table.Row>
          <Table.HeaderCell>{t('Unit')}</Table.HeaderCell>
          <Table.HeaderCell>{t('Customer')}</Table.HeaderCell>
          <Table.HeaderCell className="mobile-hide">{t('Status')}</Table.HeaderCell>
          <Table.HeaderCell>
            {t('Created')}
          </Table.HeaderCell>
          <Table.HeaderCell>
            {t('Approved')}
          </Table.HeaderCell>
          <Table.HeaderCell>{t('Loan')}</Table.HeaderCell>
          <Table.HeaderCell>{t('SPA')}</Table.HeaderCell>
          <Table.HeaderCell>{t('LA')}</Table.HeaderCell>
        </Table.Row>
      </Table.Header>
    );
  }
  renderTableRow = (data, idx) => {
    const {
      isMobile,
      isComputer,
    } = this.state;
    const { t } = this.props;

    const { bankCaseStatusTag, bankCaseUpdatedAt, bankCaseLastRemark } = (() => {
      if (!data.bankCasesStatuses || data.bankCasesStatuses.length === 0) return { bankCaseStatusTag: null, bankCaseUpdatedAt: null, bankCaseLastRemark: null };

      const bankStatus = BANK_CASE_STATUSES.find(e => e.value === data.bankCasesStatuses[0].status);
      return bankStatus ? {
        bankCaseStatusTag: <StatusFlag text={t(data.bankCasesStatuses[0].statusName, { ns: TRANSLATION_FILES.constants })} value={bankStatus.color} />,
        bankCaseUpdatedAt: data.bankCasesStatuses[0].updatedAt,
        bankCaseLastRemark: data.bankCasesStatuses[0].lastRemark,
      } : { bankCaseStatusTag: null, bankCaseUpdatedAt: null, bankCaseLastRemark: null };
    })();
    const bookingStatusTag = <StatusFlag text={t(data.bookingStatus.name, { ns: TRANSLATION_FILES.constants })} value={data.bookingStatus.id} />;
    const spaLawyer = data.spaLawyer || null;
    const laLawyer = data.laLawyer || null;
    const { spaLawyerCaseStatusTag, spaLawyerCaseUpdatedAt, spaLawyerCaseLastRemark } = (() => {
      if (!spaLawyer) return { spaLawyerCaseStatusTag: null, spaLawyerCaseUpdatedAt: null, spaLawyerCaseLastRemark: null };

      const spaLawyerStatus = LAWYER_ALL_STATUSES.find(s => s.value === spaLawyer.status);
      return spaLawyerStatus ? {
        spaLawyerCaseStatusTag: <StatusFlag text={t(spaLawyer.statusName, { ns: TRANSLATION_FILES.constants })} value={spaLawyerStatus.color} />,
        spaLawyerCaseUpdatedAt: spaLawyer.updatedAt,
        spaLawyerCaseLastRemark: spaLawyer.lastRemark,
      } : { spaLawyerCaseStatusTag: null, spaLawyerCaseUpdatedAt: null, spaLawyerCaseLastRemark: null };
    })();
    const { laLawyerCaseStatusTag, laLawyerCaseUpdatedAt, laLawyerCaseLastRemark } = (() => {
      if (!laLawyer) return { laLawyerCaseStatusTag: null, laLawyerCaseUpdatedAt: null, laLawyerCaseLastRemark: null };
      const laLawyerStatus = LAWYER_ALL_STATUSES.find(s => s.value === laLawyer.status);
      return laLawyerStatus ? {
        laLawyerCaseStatusTag: <StatusFlag text={t(laLawyer.statusName, { ns: TRANSLATION_FILES.constants })} value={laLawyerStatus.color} />,
        laLawyerCaseUpdatedAt: laLawyer.updatedAt,
        laLawyerCaseLastRemark: laLawyer.lastRemark,
      } : { laLawyerCaseStatusTag: null, laLawyerCaseUpdatedAt: null, laLawyerCaseLastRemark: null };
    })();

    return (
      <Table.Row
        key={idx}
        className={this.getRowClassName(data.status)}
        onClick={isMobile ? () => this.context.router.push(`/bookings/${data.booking_id}/`) : null}
      >
        <Table.Cell>
          {/* default view UI */}
          <div className="mobile-hide">
            <Link style={{ fontSize: 14 }} title={data.code} to={`/bookings/${data.id}/`}>
              {data.projectUnit.reference}
            </Link>
            <br />
            <span className="uc-table-cell-subtitle1">{data.project.name}</span>
          </div>
          {/* mobile view UI */}
          {/* <div className="computer-hide" style={{ display: 'flex', flexDirection: 'column', gap: '0.7em', marginTop: '0.3em' }}>
            <span>
              <div style={{ display: 'inline-flex', gap: '0.5em', alignItems: 'start' }}>
                <img src={BuildingSvg} alt="Calendar" width={20} />
                {data.projectUnit.reference} • {data.project.name}
              </div>
            </span>
            <div style={{ display: 'inline-flex', gap: '0.5em' }}>
              <img src={CalendarSvg} alt="Calendar" width={16} />
              <Timestamp
                timestamp={data.createdAt}
                format="DD/M/YYYY"
              />
            </div>
          </div> */}
        </Table.Cell>
        <Table.Cell className="mobile-hide">
          <span>
            {data.bookingCustomer && data.bookingCustomer.name}
          </span>
        </Table.Cell>
        <Table.Cell style={{ marginTop: '0.45em' }}>
          {bookingStatusTag}
        </Table.Cell>
        {/* booking created date */}
        <Table.Cell verticalAlign="middle">
          <span className="mobile-hide">
            <Timestamp
              timestamp={data.createdAt}
              format="DD/M/YYYY"
            />
          </span>
        </Table.Cell>
        {/* booking approved loan date */}
        <Table.Cell verticalAlign="middle">
          <span className="mobile-hide">
            {data.approvedAt ? (
              <Timestamp
                timestamp={data.approvedAt}
                format="DD/M/YYYY"
              />
            ) : '-'}
          </span>
        </Table.Cell>
        <Table.Cell>
          {(bankCaseStatusTag || bankCaseUpdatedAt || bankCaseLastRemark) ? (
            <div>
              <span>{bankCaseStatusTag}</span>
              <br />
              <Timestamp
                timestamp={bankCaseUpdatedAt}
                format="DD/M/YYYY"
              />
              <br />
              <span style={{ fontStyle: 'italic' }}>{bankCaseLastRemark}</span>
            </div>
          ) : t('No data', { ns: TRANSLATION_FILES.translation })}
        </Table.Cell>
        <Table.Cell>
          {spaLawyer ? (
            <div>
              <span>{spaLawyerCaseStatusTag}</span>
              <br />
              <Timestamp
                timestamp={spaLawyerCaseUpdatedAt}
                format="DD/M/YYYY"
              />
              <br />
              <span style={{ fontStyle: 'italic' }}>{spaLawyerCaseLastRemark}</span>
            </div>
          ) : t('No data', { ns: TRANSLATION_FILES.translation })}
        </Table.Cell>
        <Table.Cell>
          {laLawyer ? (
            <div>
              <span>{laLawyerCaseStatusTag}</span>
              <br />
              <Timestamp
                timestamp={laLawyerCaseUpdatedAt}
                format="DD/M/YYYY"
              />
              <br />
              <span style={{ fontStyle: 'italic' }}>{laLawyerCaseLastRemark}</span>
            </div>
          ) : t('No data', { ns: TRANSLATION_FILES.translation })}
        </Table.Cell>
      </Table.Row>
    );
  }
  render() {
    const { auth, t, location } = this.props;
    const { loading, unitProgress, menuIsTab, isComputer } = this.state;
    const { pathname } = location;
    const links = routes(auth.company.countryCode).map(l => ({
      ...l,
      text: t(l.text),
    }));
    const exportItems = [
      {
        text: 'Excel',
        icon: 'download',
        onClick: async () => {
          const { store } = this.context;
          const exportQuery = decodeSearch(location.search);
          exportQuery.page = 'all';
          this.setState({ loading: true });
          try {
            const res = await store.dispatch(fetchM(`${config.get('bookApiURL')}/bookings/export/unit_progress/?${encodeSearch(exportQuery)}`, {
              credentials: 'include',
              method: 'GET',
              headers: {
                'Content-Type': 'application/json',
              },
            }));
            if (!res.ok) {
              const message = await res.text();
              await store.dispatch(flashErrorMessage({ message }));
              return;
            }

            const blob = await res.blob();
            const contentDisposition = res.headers.get('Content-Disposition');
            let filename = 'MHub_Unit_Progress.xlsx';

            if (contentDisposition) {
              let filenameMatch = contentDisposition.match(/filename\*=UTF-8''([^;,\n\r]+)/);
              if (!filenameMatch) {
                filenameMatch = contentDisposition.match(/filename="([^"]+)"/);
              }
              if (!filenameMatch) {
                filenameMatch = contentDisposition.match(/filename=([^;,\n\r]+)/);
              }
              if (filenameMatch && filenameMatch[1]) {
                filename = decodeURIComponent(filenameMatch[1].replace(/['"]/g, ''));
              }
            }

            const url = window.URL.createObjectURL(blob);
            const downloadLink = document.createElement('a');
            downloadLink.href = url;
            downloadLink.download = filename;
            document.body.appendChild(downloadLink);
            downloadLink.click();
            downloadLink.remove();
            window.URL.revokeObjectURL(url);
          } catch (err) {
            await store.dispatch(flashErrorMessage({ message: t('An error occurred, please refresh page', { ns: TRANSLATION_FILES.translation }) }));
          } finally {
            this.setState({ loading: false });
          }
        },
      },
    ];
    return (
      <Container>
        <NavBar
          links={
            menuIsTab ?
              <Dropdown
                item
                selectOnBlur={false}
                options={links}
                onChange={this.handleMenu}
                value={pathname}
              />
            : links.map((link, key) => (
              <Menu.Item
                key={key}
                name={link.text}
                content={link.text}
                active={pathname === link.value}
                onClick={e => this.handleMenu(e, link)}
              />
            ))
          }
          // rightNav={this.hasAccess() ? (
          //   <Dropdown item text={t('Manage')}>
          //     <Dropdown.Menu>
          //       <Dropdown.Item onClick={this.handleManageClick} value="manage/">{t('Manage Pending Status')}</Dropdown.Item>
          //       {this.himsIsEnabled() && <Dropdown.Item onClick={this.handleManageClick} value="hims/">HIMS Booking Sync</Dropdown.Item>}
          //     </Dropdown.Menu>
          //   </Dropdown>
          //   ) : null
          // }
        />
        <Grid verticalAlign="middle" className="booking-list">
          {/* filter menus */}
          <Grid.Row>
            <Grid.Column>
              {this.renderMenuTool()}
            </Grid.Column>
          </Grid.Row>

          {/* data list */}
          <Grid.Row>
            <Grid.Column>
              <Dimmer
                inverted style={{ zIndex: 20 }}
                active={loading && unitProgress.length > 0}
              >
                <Loader inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
              </Dimmer>
              <Grid>
                <Grid.Row>
                  <Grid.Column mobile={10} tablet={6} computer={6} verticalAlign="middle">
                    <Header as="h3">{t('Latest Unit Progress', { ns: TRANSLATION_FILES.translation })}</Header>
                  </Grid.Column>
                  <Grid.Column mobile={6} tablet={10} computer={10}>
                    <div style={{ display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
                      {
                        exportItems.length > 0 && (
                          <Popup
                            size="tiny"
                            style={{ backgroundColor: '#596975' }}
                            basic
                            inverted
                            disabled={!isComputer}
                            content={t('Download', { ns: TRANSLATION_FILES.translation })}
                            position="bottom center"
                            trigger={
                              <div>
                                <SortButton
                                  floated="right"
                                  icon={
                                    <div
                                      style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        borderRadius: '50%',
                                        padding: '11px',
                                        transition: 'background-color 0.2s ease',
                                        cursor: 'pointer',
                                      }}
                                      onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f4f5f7'}
                                      onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                    >
                                      <img src={DownloadSvg} width={20} alt="download" />
                                    </div>
                                  }
                                  loading={loading}
                                  items={exportItems}
                                />
                              </div>
                            }
                          />
                        )
                      }
                      {/* hide sort button */}
                      {/* <Popup
                        size="tiny"
                        style={{ backgroundColor: '#596975' }}
                        basic
                        inverted
                        disabled={!isComputer}
                        content={t('Sort', { ns: TRANSLATION_FILES.translation })}
                        position="bottom center"
                        trigger={
                          <div>
                            <SortButton
                              floated="right"
                              icon={
                                <div
                                  style={{
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    borderRadius: '50%',
                                    padding: '8px',
                                    transition: 'background-color 0.2s ease',
                                    cursor: 'pointer',
                                  }}
                                  onMouseEnter={e => e.currentTarget.style.backgroundColor = '#f4f5f7'}
                                  onMouseLeave={e => e.currentTarget.style.backgroundColor = 'transparent'}
                                >
                                  <img src={SortSvg} width={24} alt="sort" />
                                </div>
                              }
                              loading={loading}
                              items={sortItems}
                              onSort={this.handleSortData}
                            />
                          </div>
                        }
                      /> */}
                    </div>
                  </Grid.Column>
                </Grid.Row>
                <Grid.Row>
                  <Grid.Column width={16}>
                    <div style={{ overflowX: 'auto' }}>
                      <Table className="uc-table uc-booking-list-table" basic="very" sortable>
                        {this.renderTableHeaders()}
                        <Table.Body>
                          {
                            unitProgress.length > 0 ?
                              unitProgress.map(this.renderTableRow) : (
                                <Table.Row>
                                  <Table.Cell colSpan={10} textAlign="center">
                                    {
                                      loading ?
                                        <Loader active inline="centered">{t('Loading', { ns: TRANSLATION_FILES.translation })}</Loader>
                                      : <p>{t('No unit progress found', { ns: TRANSLATION_FILES.translation })}.</p>
                                    }
                                  </Table.Cell>
                                </Table.Row>
                              )
                          }
                        </Table.Body>
                      </Table>
                    </div>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column textAlign="center">
              <PageNav
                upward
                currentPage={this.state.currentPage}
                count={this.state.count}
                limit={this.state.limit}
                offset={this.state.offset}
                dataSize={unitProgress.length}
                loading={loading}
                onChange={this.handleChangePage}
                // noScrollTop={this.props.noScrollTop}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Container>
    );
  }
}

export default
  withTranslation(namespaces)(withRouter(connect(UnitProgress.mapStateToProps)(UnitProgress)));



// WEBPACK FOOTER //
// ./src/containers/Bookings/UnitProgress/UnitProgress.jsx